import { request } from './client';
import { StatsResponse } from '../types/stats';

export async function fetchStats(): Promise<StatsResponse> {
  return request<StatsResponse>('/stats');
}
